import React from 'react';
import { Button, Typography } from '@material-ui/core';
import Stack from '@mui/material/Stack';
import Link from 'next/link';

export const About7 = () => {
  return (
    <div className="about-main-container">
      <div className="about-cover about-7-image" />
      <div className="container">
        <Stack spacing={3} className="about-stack about-7-stack">
          <div className="about-title">
            Book your free call today to discuss how we can help you kickstart
            your music career
          </div>
          <Typography className="about-description">
            We’re happy to answer any questions you have and help explain more
            about the tools we offer artists on our platform. Click the button
            below to book your free fifteen minute call.
          </Typography>
          <a
            href={'https://doodle.com/bp/peterruppert1/musicart'}
            target="_blank"
          >
            <Button className="about-7-button">Book Your Free Call</Button>
          </a>
          <Stack
            spacing={1}
            style={{
              paddingTop: '1rem',
            }}
          >
            <Typography className="footer_note">
              Note: Clicking the button will take you to an external link to
              book your call with MusicArt.
            </Typography>
          </Stack>
        </Stack>
      </div>
    </div>
  );
};
